import * as Sentry from '@sentry/browser';
import {detect} from 'detect-browser';
import setupSentry from 'common/setupSentry.js';

function parseBrowserVersion(version) {
    return parseInt(version?.split('.')[0]);
}

Sentry.init({
    dsn: 'https://0bfe145d33a649c59eb9cef4fbf64081@app.getsentry.com/90683',
    integrations: [new Sentry.BrowserTracing()],
    tracesSampleRate: 0.002, // sampling rate (0.0 - 1.0)
    debug: false,
    beforeSend(event, hint) {
        const browser = detect();
        if (browser && browser?.name === 'chrome') {
            const version = parseBrowserVersion(browser.version);
            if (version < 79) {
                return;
            }
        }
        if (browser && browser?.name === 'firefox') {
            const version = parseBrowserVersion(browser.version);
            if (version < 70) {
                return;
            }
        }
        return event;
    },
});

setupSentry(Sentry);
